/**
 * 组合输出的错误格式
 * @param code
 * @param message
 */
export function combineError(code?: string, message?: string) {
    return `${code || "UNKNOWN"}:${message}`;
}
